export default 'Mon Mar 28 10:50:36 UTC 2022';
